import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

import { theme } from '../../../tailwind-theme';
import { ReactComponent as DropdownChevron } from '../../assets/icons/down-chevron.svg';

export const DropdownMenuIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon component={DropdownChevron} sx={{ marginRight: theme.margin['4'] }} {...props} />
);
